export default __webpack_public_path__ + "static/media/Standard09.c5307780.png";